// import React, { useState } from "react";
// import axios from "axios";
// import { useNavigate, Link } from "react-router-dom";
// import { FaEye, FaEyeSlash, FaSpinner } from "react-icons/fa";
// import { API_BASE_URL } from '../utils/urls.js';
// import NpsnLogo from '../../assets/npsn_logo.png';

// const Login = () => {
//   const [email, setEmail] = useState("");
//   const [ORGID, setORGID] = useState("");
//   const [password, setPassword] = useState("");
//   const [showPassword, setShowPassword] = useState(false);
//   const [error, setError] = useState("");
//   const [termsAccepted, setTermsAccepted] = useState(true);
//   const [isClient, setIsClient] = useState(false);
//   const [isLoading, setIsLoading] = useState(false);
  
//   const navigate = useNavigate();

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setError("");

//     if (!termsAccepted) {
//       setError("You must accept the terms and conditions.");
//       return;
//     }

//     setIsLoading(true);

//     try {
//       const response = await axios.post(
//         API_BASE_URL + "/auth/login",
//         {
//           email,
//           password,
//           org_id: isClient ? ORGID : null
//         }
//       );

//       localStorage.setItem("token", response.data.token);
//       localStorage.setItem("user", JSON.stringify(response.data.user));

//       const roleName = response.data.user.roleName;
//       switch (roleName) {
//         case "super_admin":
//           navigate("/dashboard/super_admin");
//           break;
//         case "admin":
//           navigate("/dashboard/admin");
//           break;
//         case "case_manager":
//           navigate("/dashboard/case-manager");
//           break;
//         case "field_agent":
//           navigate("/dashboard/field-agent");
//           break;
//         case "client":
//           navigate("/dashboard/client");
//           break;
//         case "servers":
//           navigate("/dashboard/server");
//           break;
//         default:
//           navigate("/dashboard");
//       }
//     } catch (err) {
//       setIsLoading(false);
//       setError(
//         err.response?.data?.message ||
//         "Login failed. Please check your credentials."
//       );
//     }
//   };

//   return (
//     <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 px-4">
//       <div className="relative w-full max-w-sm p-6 sm:p-8 bg-white rounded-2xl shadow-lg">
        
//         {/* Floating logo - Clickable */}
//         <div className="absolute left-1/2 -top-16 -translate-x-1/2">
//           <Link 
//             to="/" 
//             className="flex p-2 items-center justify-center h-full overflow-hidden hover:scale-105 transition-transform duration-200"
//             title="Go to Home"
//           >
//             <h1 className="text-5xl font-bold text-sky-600">IntelServe</h1>
//           </Link>
//         </div>

//         <h2 className="text-2xl sm:text-3xl font-bold text-center mb-6 text-gray-800">
//           Log in
//         </h2>
//         <form onSubmit={handleSubmit} className="space-y-4">
//           <div>
//             <input
//               type="email"
//               value={email}
//               onChange={(e) => setEmail(e.target.value)}
//               placeholder="Email Address"
//               required
//               disabled={isLoading}
//               className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-gray-100"
//             />
//           </div>
//           <div className="relative">
//             <input
//               type={showPassword ? "text" : "password"}
//               value={password}
//               onChange={(e) => setPassword(e.target.value)}
//               placeholder="Password"
//               required
//               disabled={isLoading}
//               className="w-full pr-10 px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-gray-100"
//             />
//             <button
//               type="button"
//               className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-500 hover:text-gray-700"
//               onClick={() => setShowPassword(!showPassword)}
//               disabled={isLoading}
//             >
//               {showPassword ? <FaEyeSlash /> : <FaEye />}
//             </button>
//           </div>
//           <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between text-sm gap-2 sm:gap-0">
//             <div className="flex items-center">
//               <input
//                 type="checkbox"
//                 id="client-login-checkbox"
//                 checked={isClient}
//                 onChange={(e) => setIsClient(e.target.checked)}
//                 disabled={isLoading}
//                 className="mr-2 h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
//               />
//               <label htmlFor="client-login-checkbox" className="text-gray-900 text-left cursor-pointer">
//                 Client Login
//               </label>
//             </div>
//             {isClient && (
//               <div>
//                 <input
//                   type="text"
//                   value={ORGID}
//                   onChange={(e) => setORGID(e.target.value)}
//                   placeholder="ORG ID"
//                   required={isClient}
//                   disabled={isLoading}
//                   className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-gray-100"
//                 />
//               </div>
//             )}
//           </div>
//           <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between text-sm gap-2 sm:gap-0">
//             <div className="flex items-center">
//               <input
//                 type="checkbox"
//                 id="terms"
//                 checked={termsAccepted}
//                 onChange={(e) => setTermsAccepted(e.target.checked)}
//                 disabled={isLoading}
//                 className="mr-2 h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
//               />
//               <label htmlFor="terms" className="text-gray-900 text-left cursor-pointer">
//                 <a href="/terms" className="text-blue-600 hover:underline">
//                   Terms
//                 </a>
//                 {" "}and{" "}
//                 <a href="/privacy-policy" className="text-blue-600 hover:underline">
//                   Privacy Policy
//                 </a>
//               </label>
//             </div>
//             <Link
//               to="/forgotpassword"
//               className={`text-blue-600 hover:underline text-right ${isLoading ? 'pointer-events-none text-gray-400' : ''}`}
//             >
//               Forgot password?
//             </Link>
//           </div>
          
//           <button
//             type="submit"
//             disabled={isLoading}
//             className={`w-full text-white py-2 rounded-md transition duration-300 flex items-center justify-center 
//               ${isLoading 
//                 ? 'bg-blue-400 cursor-not-allowed' 
//                 : 'bg-blue-600 hover:bg-blue-700'
//               }`}
//           >
//             {isLoading ? (
//               <>
//                 <FaSpinner className="animate-spin mr-2" />
//                 Processing...
//               </>
//             ) : (
//               "Log In"
//             )}
//           </button>

//         </form>
//         {error && <p className="mt-4 text-red-500 text-center">{error}</p>}
//         <p className="mt-4 text-center text-sm text-gray-600">
//           Don't have an account?{" "}
//           <Link to="/subscriptions" className={`text-blue-600 hover:underline ${isLoading ? 'pointer-events-none text-gray-400' : ''}`}>
//             Create new account
//           </Link>
//         </p>
//       </div>
//     </div>
//   );
// };

// export default Login;



import React, { useState } from "react";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import { FaEye, FaEyeSlash, FaSpinner } from "react-icons/fa";
import { API_BASE_URL } from "../utils/urls.js";
import NpsnLogo from "../../assets/npsn_logo.png";

const Login = () => {
  const [email, setEmail] = useState("");
  const [ORGID, setORGID] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [termsAccepted, setTermsAccepted] = useState(true);
  const [isClient, setIsClient] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!termsAccepted) {
      setError("You must accept the terms and conditions.");
      return;
    }

    setIsLoading(true);

    try {
      const response = await axios.post(API_BASE_URL + "/auth/login", {
        email,
        password,
        org_id: isClient ? ORGID : null,
      });

      localStorage.setItem("token", response.data.token);
      localStorage.setItem("user", JSON.stringify(response.data.user));

      // Retrieve user payload and onboarding status AFTER a successful response
      const userPayload = response.data.user;
      const roleName = userPayload.roleName;
      const hasCompletedOnboarding = userPayload.organization?.isOnboarded === 1 || userPayload.organization?.isOnboarded === true;

      switch (roleName) {
        case "super_admin":
          navigate("/dashboard/super_admin");
          break;
        case "admin":
          // NEW REDIRECT LOGIC HERE
          if (!hasCompletedOnboarding) {
            // Redirect based on role
            if (response.data.user.roleName === 'admin') {
                navigate("/dashboard/admin");
            } else if (response.data.user.roleName === 'case_manager') {
                navigate("/dashboard/case-manager");
            } else if (response.data.user.roleName === 'field_agent') {
                navigate("/dashboard/field-agent");
            } else if (response.data.user.roleName === 'servers') {
                navigate("/dashboard/server");
            } else if (response.data.user.roleName === 'client') {
                navigate("/dashboard/client");
            } else {
                navigate("/cases");
            }
          } else {
            navigate("/dashboard/admin");
          }
          break;
        case "case_manager":
          navigate("/dashboard/case-manager");
          break;
        case "field_agent":
          navigate("/dashboard/field-agent");
          break;
        case "client":
          navigate("/dashboard/client");
          break;
        case "servers":
          navigate("/dashboard/server");
          break;
        default:
          navigate("/dashboard");
      }
    } catch (err) {
      setIsLoading(false);
      setError(
        err.response?.data?.message ||
          "Login failed. Please check your credentials."
      );
    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 px-4">
      <div className="relative w-full max-w-sm p-6 sm:p-8 bg-white rounded-2xl shadow-lg">
        {/* Floating logo - Clickable */}
        <div className="absolute left-1/2 -top-16 -translate-x-1/2">
          <Link
            to="/"
            className="flex p-2 items-center justify-center h-full overflow-hidden hover:scale-105 transition-transform duration-200"
            title="Go to Home"
          >
            <h1 className="text-5xl font-bold text-sky-600">IntelServe</h1>
          </Link>
        </div>

        <h2 className="text-2xl sm:text-3xl font-bold text-center mb-6 text-gray-800">
          Log in
        </h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Email Address"
              required
              disabled={isLoading}
              className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-gray-100"
            />
          </div>
          <div className="relative">
            <input
              type={showPassword ? "text" : "password"}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Password"
              required
              disabled={isLoading}
              className="w-full pr-10 px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-gray-100"
            />
            <button
              type="button"
              className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-500 hover:text-gray-700"
              onClick={() => setShowPassword(!showPassword)}
              disabled={isLoading}
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </button>
          </div>
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between text-sm gap-2 sm:gap-0">
            <div className="flex items-center">
              <input
                type="checkbox"
                id="client-login-checkbox"
                checked={isClient}
                onChange={(e) => setIsClient(e.target.checked)}
                disabled={isLoading}
                className="mr-2 h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
              />
              <label
                htmlFor="client-login-checkbox"
                className="text-gray-900 text-left cursor-pointer"
              >
                Client Login
              </label>
            </div>
            {isClient && (
              <div>
                <input
                  type="text"
                  value={ORGID}
                  onChange={(e) => setORGID(e.target.value)}
                  placeholder="ORG ID"
                  required={isClient}
                  disabled={isLoading}
                  className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-gray-100"
                />
              </div>
            )}
          </div>
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between text-sm gap-2 sm:gap-0">
            <div className="flex items-center">
              <input
                type="checkbox"
                id="terms"
                checked={termsAccepted}
                onChange={(e) => setTermsAccepted(e.target.checked)}
                disabled={isLoading}
                className="mr-2 h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
              />
              <label
                htmlFor="terms"
                className="text-gray-900 text-left cursor-pointer"
              >
                <a href="/terms" className="text-blue-600 hover:underline">
                  Terms
                </a>{" "}
                and{" "}
                <a
                  href="/privacy-policy"
                  className="text-blue-600 hover:underline"
                >
                  Privacy Policy
                </a>
              </label>
            </div>
            <Link
              to="/forgotpassword"
              className={`text-blue-600 hover:underline text-right ${
                isLoading ? "pointer-events-none text-gray-400" : ""
              }`}
            >
              Forgot password?
            </Link>
          </div>

          <button
            type="submit"
            disabled={isLoading}
            className={`w-full text-white py-2 rounded-md transition duration-300 flex items-center justify-center 
              ${
                isLoading
                  ? "bg-blue-400 cursor-not-allowed"
                  : "bg-blue-600 hover:bg-blue-700"
              }`}
          >
            {isLoading ? (
              <>
                <FaSpinner className="animate-spin mr-2" />
                Processing...
              </>
            ) : (
              "Log In"
            )}
          </button>
        </form>
        {error && <p className="mt-4 text-red-500 text-center">{error}</p>}
        <p className="mt-4 text-center text-sm text-gray-600">
          Don't have an account?{" "}
          <Link
            to="/subscriptions"
            className={`text-blue-600 hover:underline ${
              isLoading ? "pointer-events-none text-gray-400" : ""
            }`}
          >
            Create new account
          </Link>
        </p>
      </div>
    </div>
  );
};

export default Login;